var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "vuesax/bold/moneys" } }, [
        _c("g", { attrs: { id: "moneys" } }, [
          _c("path", {
            attrs: {
              id: "Vector",
              d:
                "M19.17 6.63953C18.74 4.46953 17.13 3.51953 14.89 3.51953H6.10996C3.46996 3.51953 1.70996 4.83953 1.70996 7.91953V13.0695C1.70996 15.2895 2.61996 16.5895 4.11996 17.1495C4.33996 17.2295 4.57996 17.2995 4.82996 17.3395C5.22996 17.4295 5.65996 17.4695 6.10996 17.4695H14.9C17.54 17.4695 19.3 16.1495 19.3 13.0695V7.91953C19.3 7.44953 19.26 7.02953 19.17 6.63953ZM5.52996 11.9995C5.52996 12.4095 5.18996 12.7495 4.77996 12.7495C4.36996 12.7495 4.02996 12.4095 4.02996 11.9995V8.99953C4.02996 8.58953 4.36996 8.24953 4.77996 8.24953C5.18996 8.24953 5.52996 8.58953 5.52996 8.99953V11.9995ZM10.5 13.1395C9.03996 13.1395 7.85996 11.9595 7.85996 10.4995C7.85996 9.03953 9.03996 7.85953 10.5 7.85953C11.96 7.85953 13.14 9.03953 13.14 10.4995C13.14 11.9595 11.96 13.1395 10.5 13.1395ZM16.96 11.9995C16.96 12.4095 16.62 12.7495 16.21 12.7495C15.8 12.7495 15.46 12.4095 15.46 11.9995V8.99953C15.46 8.58953 15.8 8.24953 16.21 8.24953C16.62 8.24953 16.96 8.58953 16.96 8.99953V11.9995Z",
              fill: _vm.color
            }
          }),
          _c("path", {
            attrs: {
              id: "Vector_2",
              d:
                "M22.3 10.9183V16.0683C22.3 19.1483 20.54 20.4783 17.89 20.4783H9.11001C8.36001 20.4783 7.69001 20.3683 7.11001 20.1483C6.64001 19.9783 6.23001 19.7283 5.90001 19.4083C5.72001 19.2383 5.86001 18.9683 6.11001 18.9683H14.89C18.59 18.9683 20.79 16.7683 20.79 13.0783V7.91832C20.79 7.67832 21.06 7.52832 21.23 7.70832C21.91 8.42832 22.3 9.47832 22.3 10.9183Z",
              fill: _vm.color
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }